export default __webpack_public_path__ + "static/media/a001-ransomware-02.59a66757.png";